// extracted by mini-css-extract-plugin
export var breadcrumb = "_redotech-redo-web-src-breadcrumb-breadcrumb";
export var breadcrumbArrow = "_redotech-redo-web-src-breadcrumb-breadcrumb-arrow";
export var breadcrumbs = "_redotech-redo-web-src-breadcrumb-breadcrumbs";
export var link = "_redotech-redo-web-src-breadcrumb-link";
export var small = "_redotech-redo-web-src-breadcrumb-small";